
const getCurrentFourDigitYear = () => new Date().getFullYear().toString();

export default getCurrentFourDigitYear;
